import { map } from "lodash";
import { IAppointmentManagementGroupingModel, AppointmentManagementGroupingModel, CommunicationPreferenceModel, ICommunicationPreferenceModel } from ".";

export interface IAppointmentManagementListModel {
    name: string;
    description: string;
    sortOrder: number;
    canViewWhatToExpect: boolean;
    groups: IAppointmentManagementGroupingModel[];
    communicationPreference: ICommunicationPreferenceModel;
    showCommunicationPreference: boolean;
}

export class AppointmentManagementListModel implements IAppointmentManagementListModel {
    name: string;
    description: string;
    sortOrder: number;
    canViewWhatToExpect: boolean;
    groups: AppointmentManagementGroupingModel[] = [];
    communicationPreference: CommunicationPreferenceModel;
    showCommunicationPreference: boolean;

    constructor(params: Partial<IAppointmentManagementListModel> = {}) {
        const {
            name = '',
            description = '',
            sortOrder = 0,
            canViewWhatToExpect = false,
            groups = [] as Array<IAppointmentManagementGroupingModel>
        } = params;

        this.name = name;
        this.description = description;
        this.sortOrder = sortOrder;
        this.canViewWhatToExpect = canViewWhatToExpect;
        map(groups, (group) => { this.groups.push(new AppointmentManagementGroupingModel(group)); });
        this.communicationPreference = params?.communicationPreference ? new CommunicationPreferenceModel(params?.communicationPreference) : new CommunicationPreferenceModel();
        this.showCommunicationPreference = _.defaultTo(params?.showCommunicationPreference, false);

    }
}
